export default {
  path: "/signing",
  name: "signing",
  component: () => import("@/views/signing/SigningBase.vue"),
  children: [
    {
      path: ":id/document",
      name: "signing_document",
      component: () => import("@/views/signing/Document.vue")
    },
    {
      path: ":id/complete",
      name: "signing_complete",
      component: () => import("@/views/signing/Complete.vue")
    },
    {
      path: ":id/view",
      name: "signing_view",
      component: () => import("@/views/dashboard/signing/ViewSigning.vue")
    }
  ]
}
